export const CASHFLOW_DATA = {
  metrics: [
    { label: 'Cash Balance', value: '$2.4M', trend: '+$180K', trendUp: true },
    { label: 'Monthly Burn', value: '$320K', trend: '-$15K', trendUp: true },
    { label: 'Runway', value: '7.5 mo', trend: '+0.3', trendUp: true },
    { label: 'Receivables', value: '$890K', trend: '+$120K', trendUp: false, alert: true },
    { label: 'Payables', value: '$410K', trend: '-$25K', trendUp: true },
    { label: 'Net Cash Flow', value: '+$62K', trend: '+$18K', trendUp: true },
  ],
  waterfall: [
    { category: 'Revenue', amount: 520000, type: 'inflow' },
    { category: 'Services', amount: 85000, type: 'inflow' },
    { category: 'Payroll', amount: -245000, type: 'outflow' },
    { category: 'Vendors', amount: -98000, type: 'outflow' },
    { category: 'Infrastructure', amount: -62000, type: 'outflow' },
    { category: 'Marketing', amount: -45000, type: 'outflow' },
    { category: 'Tax & Compliance', amount: -38000, type: 'outflow' },
    { category: 'Other', amount: -55000, type: 'outflow' },
  ],
  receivables: [
    { id: 'r1', client: 'Acme Corp', amount: '$185K', daysOverdue: 42, status: 'critical', invoice: 'INV-2024-089', contact: 'Sarah Kim' },
    { id: 'r2', client: 'Vertex Labs', amount: '$120K', daysOverdue: 28, status: 'overdue', invoice: 'INV-2024-091', contact: 'James Liu' },
    { id: 'r3', client: 'NovaTech', amount: '$95K', daysOverdue: 15, status: 'overdue', invoice: 'INV-2024-094', contact: 'Mike Torres' },
    { id: 'r4', client: 'CloudNine', amount: '$210K', daysOverdue: 7, status: 'due-soon', invoice: 'INV-2024-096', contact: 'Lisa Chen' },
    { id: 'r5', client: 'Pinnacle Systems', amount: '$78K', daysOverdue: 0, status: 'current', invoice: 'INV-2024-098', contact: 'Dan Park' },
    { id: 'r6', client: 'AgriTech Co', amount: '$62K', daysOverdue: 35, status: 'overdue', invoice: 'INV-2024-088', contact: 'Priya Das' },
  ],
  payables: [
    { id: 'p1', vendor: 'AWS', amount: '$42K', dueDate: 'Feb 3', category: 'Infrastructure', recurring: true, status: 'due' },
    { id: 'p2', vendor: 'Salesforce', amount: '$18K', dueDate: 'Feb 5', category: 'SaaS', recurring: true, status: 'due' },
    { id: 'p3', vendor: 'McKinsey Advisory', amount: '$85K', dueDate: 'Feb 10', category: 'Consulting', recurring: false, status: 'pending-approval' },
    { id: 'p4', vendor: 'WeWork', amount: '$22K', dueDate: 'Feb 15', category: 'Office', recurring: true, status: 'scheduled' },
    { id: 'p5', vendor: 'HubSpot', amount: '$8.5K', dueDate: 'Feb 18', category: 'SaaS', recurring: true, status: 'scheduled' },
  ],
  insights: [
    { id: 'ci1', type: 'alert', text: 'Acme Corp receivable ($185K) is 42 days overdue — longest in 6 months. Recommend escalation to VP Sales before month-end.', time: '2 hrs ago' },
    { id: 'ci2', type: 'insight', text: 'Cash position improves to $2.6M if Vertex Labs and NovaTech pay within 10 days. Both have historically paid within 5 days of reminder.', time: '3 hrs ago' },
    { id: 'ci3', type: 'recommendation', text: 'McKinsey advisory fee ($85K) is a one-time engagement. Suggest deferring to March to maintain runway above 7 months.', time: '4 hrs ago' },
    { id: 'ci4', type: 'insight', text: 'Dora flagged: Infrastructure costs trending 12% above Q4 average. AWS spend spike correlates with v2.3 deployment — likely temporary.', time: '5 hrs ago' },
  ],
};

export const CASHFLOW_CHAT_RESPONSES = {
  general: { text: "I'm tracking all cash movements in real-time. Our position is healthy at $2.4M with 7.5 months runway. The main concern is $890K in receivables — I'll prioritize collection efforts on the overdue accounts. What would you like me to focus on?" },
};
